import { type MutationResponse, useApolloMutationWrapper } from '../../../api'
import { useRescheduleDashboardOrderMutation } from '../../../../api'
import {
  type RescheduleDashboardOrderResponse,
  type RescheduleDashboardOrderRequestParams,
  type RescheduleDashboardOrderMeshResponse,
} from './types'

function mapResponse(data: RescheduleDashboardOrderMeshResponse): RescheduleDashboardOrderResponse {
  const payload =
    data.instacart_enterprise_frigate_fulfillment_v1_DashboardOrderService_RescheduleDashboardOrder

  if (payload?.operation?.error) {
    return {
      name: payload?.operation?.name ?? '',
      isDone: payload?.operation?.isDone ?? false,
      error: {
        typedErrors:
          payload?.operation?.error?.typedErrors?.map(error => ({
            errorType: error?.errorType ?? 'UNKNOWN_ERROR',
          })) ?? [],
      },
    }
  }

  return {
    name: payload?.operation?.name ?? '',
    isDone: payload?.operation?.isDone ?? false,
    value: {
      deliveryReference: payload?.operation?.value?.deliveryReference ?? '',
    },
  }
}

export const useRescheduleDashboardOrder = (): MutationResponse<
  RescheduleDashboardOrderResponse,
  RescheduleDashboardOrderRequestParams
> => {
  const mutationTuple = useRescheduleDashboardOrderMutation({
    variables: undefined,
    fetchPolicy: 'network-only',
  })

  return useApolloMutationWrapper({ mutationTuple, mapResponse })
}
